import React, { useState } from 'react';
import SideBar from "../commanComponents/sidebar/sidebar";

import "./studentNotes.css";
import { sidebarNavItems, COMMING_SOON_IMAGE } from "../../constant";
// import { Document, Page, pdfjs } from "react-pdf";
import TopNavigation from "../commanComponents/topNavigation/topNavigation";


// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const StudentNotes = (props) => {
    // const [numPages, setNumPages] = useState(null);
    // const [pageNumber, setPageNumber] = useState(1);
    

    // const onDocumentLoadSuccess = (numPages) => {
    //     setNumPages(numPages);
    //     setPageNumber(1);
    // }
    return (
        <div className='forum-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.studentNotes} />
            <div className='forum-side-container'>
                <TopNavigation activeItem={sidebarNavItems.studentNotes} />
                
                <div className='row forum-filter-container'>
                    
                </div>
                
                {/* <div className='profile-main-container'>
                    <div className='row'>
                        <div className='col'>
                        <h5>My details</h5>
                        </div>
                        <div className='col profile-header-right'>
                            <PrimaryButton
                                text="Edit"
                                isLoading={isLoading}
                                onClick={handleEditButton}
                            />
                        </div>
                    </div>
                    
                    <hr className="profile-border" />
                    <Document
                        file={'https://fizrobotics-assets.s3.ap-south-1.amazonaws.com/student-notes/student_list_JPSN_9th.pdf'}
                        onLoadSuccess={onDocumentLoadSuccess}
                    >
                        <Page pageNumber={pageNumber} />
                    </Document>
                </div> */}
                <div className='forum-comming-soon'>
                    <h1 className='forum-comming-soon-text'>Coming Soon</h1>
                    <img
                        src={COMMING_SOON_IMAGE}
                        className='forum-comming-soon-img'
                        alt="coming soon"
                    />
                </div>
            </div>
        </div>
    );
}


export default StudentNotes;
